import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import moment from 'moment';
import { formatDate } from '../format';

// TODO: replace moment with DateUtils

export class DateStore {
    static PropType = PropTypes.shape({
        monthTitle: PropTypes.string.isRequired,
        daysOfMonth: MobxPropTypes.arrayOrObservableArray,
        showPrevMonth: PropTypes.func.isRequired,
        showNextMonth: PropTypes.func.isRequired,
        setDay: PropTypes.func.isRequired,
    });

    constructor(date) {
        extendObservable(this, /** @class DateStore */{
            date: date ? moment(date) : null,
            monthTitleFormat: 'MMMM YYYY',
            anchor: moment(date).startOf('month'),
            get monthTitle() {
                return this.anchor.format(this.monthTitleFormat);
            },
            get daysOfMonth() {
                return [
                    // Sunday is 0...
                    ...new Array((this.anchor.day() + 7 - 1) % 7).fill(''),
                    ...new Array(this.anchor.daysInMonth()).fill('').map((_, i) => i + 1),
                ];
            },
            get selectedDay() {
                return this.date && this.date.isSame(this.anchor, 'month') ? this.date.date() : -1;
            },
        });
    }

    showPrevMonth = action(() => {
        this.anchor = this.anchor.clone().subtract(1, 'months');
    });

    showNextMonth = action(() => {
        this.anchor = this.anchor.clone().add(1, 'months');
    });

    setDate = action((date) => {
        if (date) {
            this.date = date;
            this.anchor = this.date.clone().startOf('month');
        } else {
            this.date = null;
            this.anchor = moment().startOf('month');
        }
    });

    setDay = action((day) => this.setDate(this.anchor.clone().date(day)));
}

export default class DateRangeStore {
    static PropType = PropTypes.shape({
        start: DateStore.PropType.isRequired,
        end: DateStore.PropType.isRequired,
        daysOfWeek: MobxPropTypes.arrayOrObservableArray,
        label: PropTypes.string.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class DateRangeStore */{
            from: null,
            to: null,
            start: new DateStore(),
            end: new DateStore(),

            get daysOfWeek() {
                return moment.weekdays().map((title) => title[0].toUpperCase());
            },

            get label() {
                if (!this.from || !this.to) {
                    return 'select…';
                }
                return `${formatDate(moment(this.from))} to ${formatDate(moment(this.to))}`;
            },
        }, data);
    }

    reset = action(() => {
        this.start.setDate(this.from ? moment(this.from) : null);
        this.end.setDate(this.to ? moment(this.to) : null);
    });

    apply = action(() => {
        this.from = this.start.date;
        this.to = this.end.date;
    });

    configure = action((from, to) => {
        this.start.setDate(from);
        this.end.setDate(to);
        this.apply();
    });
}
